import React, { useState } from 'react';
import {
  FooterWarningConsentText, FooterWarningConsentLink, FooterWarningConsentLinkSeparator, FooterWarningConsentLinksContainer
} from './FooterWarningConsent.styled';

import { ModalContentFull } from '../../../common/sharedComponents/ModalContentFull';
import { TermsAndConditions } from '../Policies/TermsAndConditions';
import { PrivacyPolicy } from '../Policies/PrivacyPolicy';
// import { CookiePolicy } from '../Policies/CookiePolicy';

export function FooterWarningConsent () {

  const [footerWarningConsentModalOpen, setFooterWarningConsentModalOpen] = React.useState<boolean>(false);
  const [selectedTerm, setSelectedTerm] = useState<string>('');

  function toggleConsentModal (whichTerm: string) {
    setSelectedTerm(whichTerm);
    setFooterWarningConsentModalOpen(!footerWarningConsentModalOpen);
  }

  return (
    <>
      {footerWarningConsentModalOpen && (
        <ModalContentFull handleModalClose={() => setFooterWarningConsentModalOpen(!footerWarningConsentModalOpen)}>
          {selectedTerm === 'TermsAndConditions' && <TermsAndConditions />}

          {selectedTerm === 'PrivacyPolicy' && <PrivacyPolicy />}

          {/* {selectedTerm === 'CookiePolicy' && <CookiePolicy />} */}
        </ModalContentFull>
      )}
      {!footerWarningConsentModalOpen && (
        <>
          <FooterWarningConsentText>
            By using myLQA, you agree and consent to our
          </FooterWarningConsentText>
          <FooterWarningConsentLinksContainer>
            <FooterWarningConsentLink onClick={() => toggleConsentModal('TermsAndConditions')}>
              Terms of Service
            </FooterWarningConsentLink>
            <FooterWarningConsentLinkSeparator>-</FooterWarningConsentLinkSeparator>
            {/* <FooterWarningConsentLink onClick={() => setFooterWarningConsentModalOpen(!footerWarningConsentModalOpen)}>
              Cookie Policy
            </FooterWarningConsentLink>
            <FooterWarningConsentLinkSeparator>-</FooterWarningConsentLinkSeparator> */}
            <FooterWarningConsentLink onClick={() => toggleConsentModal('PrivacyPolicy')}>
              Privacy Policy
            </FooterWarningConsentLink>
          </FooterWarningConsentLinksContainer>
        </>
      )}
    </>
  );
}
